import { render } from "./CreateIpv4SubnetForNetwork.vue?vue&type=template&id=1ee3f200&scoped=true"
import script from "./CreateIpv4SubnetForNetwork.vue?vue&type=script&lang=js"
export * from "./CreateIpv4SubnetForNetwork.vue?vue&type=script&lang=js"

import "./CreateIpv4SubnetForNetwork.vue?vue&type=style&index=0&id=1ee3f200&lang=scss&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee3f200"]])

export default __exports__